export default "__VITE_ASSET__BPm9Vg66__"